export default {
    HOST_ORIGIN: window.location.origin,
    BASE_URL: process.env.VUE_APP_BASE_URL,
    ABS_PATH: process.env.VUE_APP_ABS_PATH,
    ABS_HOST: process.env.VUE_APP_ABS_HOST,
    APP_KEY: process.env.VUE_APP_APP_KEY,
    APP_KEYT: process.env.VUE_APP_APP_KEYT,
    DEVICE_ID: navigator.userAgent,
    IS_NEIWANG: process.env.VUE_APP_IS_NEIWANG
};
